import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const ORGANIZATION_CHALLENGES = gql`
  query OrganizationChallenges(
    $organizationId: ID!
    $status: ChallengeStatus
    $limit: Int
    $offset: Int
  ) {
    organizationChallenges(
      organizationId: $organizationId
      status: $status
      limit: $limit
      offset: $offset
    ) {
      items {
        _id
        name
        description
        type
        metric
        targetValue
        startDate
        endDate
        photoUrl
        accessibility
        rewards {
          fromRank
          toRank
          description
        }
        status
        organizationId
        isActive
        createdAt
        updatedAt
        participantCount
        entryFee
        isPaid
        prizePool
        recurrence {
          enabled
          intervalValue
          intervalUnit
        }
        sourceTemplateId
        nextOccurrenceDate
        isStarted
        isEnded
        daysRemaining
        creator {
          _id
          firstName
          lastName
        }
      }
      totalCount
      hasMore
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const CREATE_CHALLENGE = gql`
  mutation CreateChallenge($input: CreateChallengeInput!) {
    createChallenge(input: $input) {
      _id
      name
      description
      type
      metric
      targetValue
      startDate
      endDate
      photoUrl
      accessibility
      rewards {
        fromRank
        toRank
        description
      }
      status
      organizationId
      participantCount
      entryFee
      isPaid
      prizePool
      recurrence {
        enabled
        intervalValue
        intervalUnit
      }
      createdAt
    }
  }
`;

export const UPDATE_CHALLENGE = gql`
  mutation UpdateChallenge($id: ID!, $input: UpdateChallengeInput!) {
    updateChallenge(id: $id, input: $input) {
      _id
      name
      description
      type
      metric
      targetValue
      startDate
      endDate
      photoUrl
      accessibility
      rewards {
        fromRank
        toRank
        description
      }
      status
      participantCount
      entryFee
      isPaid
      prizePool
      recurrence {
        enabled
        intervalValue
        intervalUnit
      }
      updatedAt
    }
  }
`;

export const PUBLISH_CHALLENGE = gql`
  mutation PublishChallenge($id: ID!) {
    publishChallenge(id: $id) {
      _id
      status
      isStarted
      isEnded
    }
  }
`;

export const STOP_CHALLENGE_RECURRENCE = gql`
  mutation StopChallengeRecurrence($id: ID!) {
    stopChallengeRecurrence(id: $id) {
      _id
      recurrence {
        enabled
        intervalValue
        intervalUnit
      }
    }
  }
`;
